import React, { useEffect, useState } from "react";
import { Hourglass } from "react-loader-spinner";
import HeaderMobile from "../Component/MobileHader";
import BanerSection from "../Component/BanerSection";
import CompanyDetails from "../Component/CompanyDetails";
import Services from "../Component/Services";
import ProductListing from "../Component/ProductListing";
import GallerySection from "../Component/GallerySection";
import AwordSlider from "../Component/AwordSlider";
import ProductAddModal from "../Component/ProductAddModal";
import Follows from "../Component/Follows";
import { useLocation, useNavigation, useRoutes } from "react-router-dom";

const Home = () => {
  const [loading, setLoading] = useState(true);
const [key,setKey] = useState(Math.random().toString())
const {pathname} = useLocation()


  useEffect(() => {
    setKey(Math.random().toString())


    const handleLoading = async () => {
      setLoading(true); // Start loading
      window.scrollTo(0, 0);

      // Simulate loading for demonstration purposes
      await new Promise((resolve) => setTimeout(resolve, 2000));

      setLoading(false); // Stop loading
    };

    handleLoading();
  }, [pathname]);

  return (
    <React.Fragment
    key={key}
    
    >
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Hourglass
            height={80}
            width={80}
            color="#01458e"
            visible={true}
            ariaLabel="ball-triangle-loading"
          />
        </div>
      ) : (
        <>
          <HeaderMobile />
          <BanerSection />
          <CompanyDetails />
          <Services />
          <ProductListing />
          <GallerySection />
          <AwordSlider />
          <ProductAddModal />
          <Follows />
        </>
      )}
    </React.Fragment>
  );
};

export default Home;
